// extracted by mini-css-extract-plugin
export default {"houseSize":"50","piece":"piece_piece__RCGWI"};